import { API } from 'aws-amplify';
import qs from 'qs';

async function getWorkers(
  siteId?: string,
  subcontractorId?: string,
  asCompany?: string,
  blacklisted?: "not_blacklisted" | "blacklisted" | "previously_blacklisted"
): Promise<CrewWorker[]> {
  try {
    const path = `/workers?${qs.stringify({
      siteId,
      subcontractorId,
      asCompany,
      blacklisted
    })}`;
    const data = await API.get('api-service', path, {});

    console.log(data.data);
    return data.data;
  } catch (error: any) {
    throw error;
  }
}

export default getWorkers;
